import React, { useState } from 'react';
import {
  BusinessTariffCardWithoutHeader,
  SectionTitle,
  SliderWrapper,
} from '@/ui/index';
import BusinessContactForm from '@/ui/BusinessContactForm/BusinessContactForm';

import styles from '../business-tariffs/BusinessTariffs.module.scss';

const BusinessTariffSliderWithoutHeader = ({ data }) => {
  const [tariffID, setTariffID] = useState(null);
  const [modalActive, setModalActive] = useState(false);

  const closeModal = () => {
    setModalActive(false);
    setTariffID(null);
  };

  const handleConnect = (id) => {
    setModalActive(true);
    setTariffID(id);
  };

  const renderList = (item, key) => (
    <BusinessTariffCardWithoutHeader
      key={key}
      data={item}
      handleConnect={handleConnect}
    />
  );

  return (
    <div itemScope itemType='https://schema.org/WebPage'>
      {data && (
        <div className={'section wrapper'}>
          <SectionTitle titleModify={'title--large'}>
            {data?.title}
          </SectionTitle>
          <div className={'common-description'}>{data?.description}</div>
          <SliderWrapper
            className={styles.slider}
            arrows
            options={{ infinite: data?.tariffs?.length > 3 }}
          >
            {data?.tariffs?.map(renderList)}
          </SliderWrapper>
        </div>
      )}
      <BusinessContactForm
        tariffID={tariffID}
        activeModal={modalActive}
        clearTariff={closeModal}
        hasEmployeesCount={false}
      />
    </div>
  );
};

export default BusinessTariffSliderWithoutHeader;
